<template>
    <FormItem>
        <template #question>Order Summary</template>
        <template #response>
            <v-card class="soli-round stripe-shadow" outlined>
                <v-list dense class="px-3">
                    <v-list-item>
                        <v-list-item-subtitle class="pb-0 justify-start flex"
                            >Subtotal</v-list-item-subtitle
                        ><v-spacer />
                        <v-list-item-subtitle class="flex justify-end">
                            {{ formatUnitAmount(subtotal) }}
                        </v-list-item-subtitle></v-list-item
                    >
                    <v-list-item>
                        <v-list-item-subtitle class="pb-0 justify-start flex"
                            >Tax</v-list-item-subtitle
                        ><v-spacer />
                        <v-list-item-subtitle class="flex justify-end">
                            $0.00
                        </v-list-item-subtitle></v-list-item
                    >
                    <v-list-item v-if="appliedGift">
                        <v-list-item-subtitle class="justify-start flex">{{
                            `${appliedGift.code} · ${formatUnitAmount(
                                appliedGift.amount
                            )}`
                        }}</v-list-item-subtitle>
                        <v-spacer />
                        <v-list-item-subtitle class="justify-end flex">{{
                            `- ${formatUnitAmount(appliedGift.amount)}`
                        }}</v-list-item-subtitle>
                    </v-list-item>

                    <v-list-item v-if="autoCoupons.length">
                        <div class="flex flex-col pt-3">
                            <v-list-item-subtitle class="justify-start flex"
                                >Discounts:</v-list-item-subtitle
                            >
                            <v-list-item
                                v-for="coupon in autoCoupons"
                                :key="coupon.auto_coupon_name"
                                class="w-full pr-0 py-0"
                            >
                                <v-list-item-subtitle
                                    class="justify-start flex"
                                    >{{
                                        coupon.auto_coupon_name
                                    }}</v-list-item-subtitle
                                >

                                <v-spacer />
                                <v-list-item-subtitle
                                    class="justify-end flex"
                                    >{{
                                        `- ${coupon.auto_coupon_amount_format}`
                                    }}</v-list-item-subtitle
                                >
                            </v-list-item>
                        </div>
                    </v-list-item>

                    <v-list-item v-if="appliedPromo">
                        <v-list-item-subtitle class="justify-start flex">{{
                            `${appliedPromo.code} · ${appliedPromo.name}`
                        }}</v-list-item-subtitle>

                        <v-spacer />
                        <v-list-item-subtitle class="justify-end flex">{{
                            `- ${formatUnitAmount(appliedPromo.amount)}`
                        }}</v-list-item-subtitle>
                    </v-list-item>
                    <v-list-item v-if="appliedBalance">
                        <v-list-item-subtitle class="pb-0 justify-start flex"
                            >Account Balance</v-list-item-subtitle
                        ><v-spacer />
                        <v-list-item-subtitle class="flex justify-end">
                            {{ formatUnitAmount(appliedBalance) }}
                        </v-list-item-subtitle></v-list-item
                    >
                    <v-list-item>
                        <v-list-item-subtitle class="pb-0 justify-start flex"
                            >Amount Due</v-list-item-subtitle
                        ><v-spacer />
                        <v-list-item-title
                            class="flex justify-end title soli-grey py-3"
                        >
                            {{ formatUnitAmount(totalAmountDue) }}
                        </v-list-item-title></v-list-item
                    >
                </v-list>
            </v-card>
            <div
                v-if="
                    !totalAmountDue &&
                    items.some(
                        (item) => item.lesson_id && !item.event_register_id
                    )
                "
                class="mt-4 px-1"
            >
                <p class="text-sm mb-0 text-align-start soli-grey px-1">
                    A payment method is required to register for this class.
                    Your card will not be charged.
                </p>
            </div>
            <slot name="submit"></slot>
        </template>
    </FormItem>
</template>

<script>
import FormItem from "../../Components/Form/FormItem.vue";

export default {
    components: {
        FormItem,
    },
    props: {
        errors: {},
        items: {
            type: Array,
            default: () => [],
        },
        user: {
            type: Object,
            default: () => {},
        },
        guest: {
            type: Object,
            default: () => {},
        },
        subtotal: {
            type: Number,
            default: 0,
        },
        totalAmountDue: {
            type: Number,
            default: 0,
        },
        appliedGift: {
            type: Object,
            default: () => {},
        },
        appliedPromo: {
            type: Object,
            default: () => {},
        },
        appliedBalance: {
            type: Number,
            default: 0,
        },
        autoCoupons: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style>
.short-bone {
    transform: translateY(-6px);
}
</style>
